module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAZlBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+rG8stAAAAIXRSTlMABAkKCwwTFRodHiAhKTdiZZGWl5ulqaq7vtPc3ebw8/SIyyV6AAAAXElEQVQI11XOVw6AMAwD0LD3LFCgZfj+l6RIJID/nixZJuIk86k8UbwCUNKVk+PGWm2pgZEFOC+ByDn3P8LTxT9Rpr+qzb3JogG20KLoAEzq850Ge1fJVerb8AVdwCcIrmdwnPIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/icon-edit.png
// module id = 584
// module chunks = 0